import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookAndApple1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5369_657)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M22 16.5V14.6667H15.95C16.0417 14.575 16.0875 14.5292 16.1792 14.4375C17.3708 13.1542 18.15 11.55 18.2875 10.1292C18.425 8.70833 18.0125 7.33333 17.0958 6.23333C16.1792 5.13333 14.8958 4.44583 13.5208 4.30833C12.9708 4.2625 12.4667 4.30833 11.9167 4.4C12.0083 2.97917 13.2 1.83333 14.6667 1.83333V0C12.1917 0 10.175 1.97083 10.0833 4.44583C9.53333 4.35417 9.02917 4.30833 8.47917 4.35417C7.05833 4.49167 5.775 5.17917 4.90417 6.27917C4.03333 7.37917 3.575 8.70833 3.7125 10.1292C3.85 11.5042 4.62917 13.1083 5.82083 14.4375L6.05 14.6667H2.75C1.2375 14.6667 0 15.9042 0 17.4167V19.25C0 20.7625 1.2375 22 2.75 22H22V20.1667C20.9917 20.1667 20.1667 19.3417 20.1667 18.3333C20.1667 17.325 20.9917 16.5 22 16.5ZM18.4708 19.25C18.5625 19.5708 18.7 19.8917 18.8375 20.1667H5.5V16.5H18.8375C18.6542 16.775 18.5625 17.0958 18.4708 17.4167H13.75V19.25H18.4708Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5369_657",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 22,
			fill: "white"
		})
	}) })]
});
export default SvgBookAndApple1;
